export const severityOptions = [
  { value: 'all', label: 'All Severities' },
  { value: 'critical', label: 'CRITICAL', color: 'text-red-500 bg-red-500/10' },
  { value: 'high', label: 'HIGH', color: 'text-orange-500 bg-orange-500/10' },
  { value: 'medium', label: 'MEDIUM', color: 'text-yellow-500 bg-yellow-500/10' },
  { value: 'low', label: 'LOW', color: 'text-emerald-500 bg-emerald-500/10' }
];

export const statusOptions = [
  { value: 'all', label: 'All Statuses' },
  { value: 'open', label: 'Open', color: 'text-red-500 bg-red-500/10' },
  { value: 'in_progress', label: 'In Progress', color: 'text-blue-500 bg-blue-500/10' },
  { value: 'resolved', label: 'Resolved', color: 'text-emerald-500 bg-emerald-500/10' },
  { value: 'false_positive', label: 'False Positive', color: 'text-purple-500 bg-purple-500/10' },
  { value: 'duplicate', label: 'Duplicate', color: 'text-gray-500 bg-gray-500/10' },
  { value: 'retest', label: 'Retest', color: 'text-yellow-500 bg-yellow-500/10' }
];

export const timeframeOptions = [
  { value: 'all', label: 'All Time' },
  { value: 'today', label: 'Today' },
  { value: 'week', label: 'Last 7 Days' },
  { value: 'month', label: 'Last 30 Days' },
  { value: 'quarter', label: 'Last 90 Days' }
];

export const sortOptions = [
  { value: '-created_at', label: 'Newest First' },
  { value: 'created_at', label: 'Oldest First' },
  { value: 'severity', label: 'Highest Severity' },
  { value: '-severity', label: 'Lowest Severity' },
  { value: '-updated_at', label: 'Recently Updated' },
  { value: 'updated_at', label: 'Least Recently Updated' }
];